import { asyncHandler } from '../async-handler';
import store from '../../../store/store';
import { RequestInfo } from '../../../interfaces/RequestInfo';
import { CREATE_SHOP_API } from '../../constants/central-api';
import { applicationWWWXRLEncodedBodyBuilder } from '../../utils/body-builder';

export interface CreateShopResponse {
  success: boolean;
  data?: {
    slug: string;
    id: number;
    name: string;
  };
  message?: string;
  isLimitReached?: boolean;
}

export async function createShop(name: string): Promise<CreateShopResponse> {
  const state = store.getState();
  const accessToken = state.auth.authorization.accessToken;
  const isWhiteLabel = state.UI.isWhiteLabel;
  const seller_id = state.user.profile.seller_id;

  const requestInfo: RequestInfo = {
    url: CREATE_SHOP_API(seller_id),
    method: 'POST',
    body: applicationWWWXRLEncodedBodyBuilder({
      name: name,
      currency: 'EUR',
    }),
    headers: {
      Accept: 'application/json',
      'Content-type': 'application/x-www-form-urlencoded',
      Authorization: `${accessToken.type} ${
        isWhiteLabel
          ? accessToken.currentWhiteLabelSellerToken
          : accessToken.sellerToken
      }`,
    },
  };

  const actionType = 'CREATE_SHOP';
  const customMsg = 'Company Added Successfully.';

  const res: any = await asyncHandler(
    requestInfo,
    actionType,
    customMsg,
    false,
    false,
    true
  );

  const response = res?.data;

  if (response?.success === true) {
    return {
      success: true,
      data: response.data,
    };
  } else {
    // Check if the error is related to brand limit
    const errorMessage =
      response?.message ||
      (Array.isArray(response?.errors)
        ? response.errors.join(' ')
        : typeof response?.errors === 'object'
        ? Object.values(response.errors).join(' ')
        : '') ||
      '';
    const errorMessageLower = errorMessage.toLowerCase();
    const errorCode = (response?.error || response?.error_code || '').toLowerCase();

    const isLimitReached =
      errorMessageLower.includes('limit') ||
      errorMessageLower.includes('maximum') ||
      errorMessageLower.includes('exceeded') ||
      errorMessageLower.includes('brand limit') ||
      errorMessageLower.includes('shop limit') ||
      errorCode === 'brand_limit_reached' ||
      errorCode === 'shop_limit_reached' ||
      errorCode.includes('limit');

    return {
      success: false,
      message: errorMessage,
      isLimitReached,
    };
  }
}

